import { render, staticRenderFns } from "./AiAppSettingDefinitionAdd.vue?vue&type=template&id=0c1133e4&scoped=true"
import script from "./AiAppSettingDefinitionAdd.vue?vue&type=script&lang=js"
export * from "./AiAppSettingDefinitionAdd.vue?vue&type=script&lang=js"
import style0 from "./AiAppSettingDefinitionAdd.vue?vue&type=style&index=0&id=0c1133e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1133e4",
  null
  
)

export default component.exports